// import Cookies from "js-cookie";

const AUTH_TOKEN = "SHOP-USER-TOKEN";

export function getToken() {
    return Cookies.get(AUTH_TOKEN);
}

export function setToken(token) {
    // 设置 Cookie
    return Cookies.set(AUTH_TOKEN, token, { domain: getTopLevelDomain(), path: '/' });
}

export function removeToken() {
    return Cookies.remove(AUTH_TOKEN, { domain: getTopLevelDomain(), path: '/' });
}

function getTopLevelDomain() {
    // 获取当前域名（当前页面的域名）
    const currentDomain = window.location.hostname;

    // 检查是否是IP地址
    const isIPAddress = /^(\d{1,3}\.){3}\d{1,3}$/.test(currentDomain);

    // 计算 domain 参数（一级域名或完整IP地址）
    return isIPAddress ? currentDomain : currentDomain
        .split('.')
        .slice(-2) // 获取最后两部分，通常是一级域名和顶级域名
        .join('.');
}

export function isLogin() {
    const token = getToken();
    return typeof token === "string" && token;
}

